import { RankingInfo, rankItem } from "@tanstack/match-sorter-utils";
import {
  ColumnDef,
  FilterFn,
  getCoreRowModel,
  getFilteredRowModel,
  getSortedRowModel,
  SortingState,
  useReactTable,
} from "@tanstack/react-table";
import { useState } from "react";

declare module "@tanstack/table-core" {
  interface FilterMeta {
    itemRank: RankingInfo;
  }
}

export interface UseDetailsTableOptions<DataProps extends any> {
  data: DataProps[];
  columns: ColumnDef<DataProps, any>[];
}

export function useDetailsTable<DataProps extends any>({
  data,
  columns,
}: UseDetailsTableOptions<DataProps>) {
  const [sorting, setSorting] = useState<SortingState>([]);
  const [globalFilter, setGlobalFilter] = useState("");
  const handleFilter: FilterFn<any> = (row, _columnId, value, addMeta) => {
    const results: string[] = [];

    Object.values(row.original).map((item: any) => {
      typeof item === "object"
        ? results.push(Array.isArray(item) ? item[0] : item?.name)
        : results.push(item);
    });

    const itemRank = rankItem(
      results.find((str: string) =>
        String(str).toLowerCase().includes(value.toLowerCase()),
      ),
      value,
    );

    addMeta({
      itemRank,
    });

    return itemRank.passed;
  };
  const table = useReactTable<DataProps>({
    data,
    columns,
    onSortingChange: setSorting,
    onGlobalFilterChange: setGlobalFilter,
    getFilteredRowModel: getFilteredRowModel(),
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
    state: {
      sorting,
      globalFilter,
    },
    globalFilterFn: handleFilter,
  });
  return {
    table,
    setGlobalFilter,
    globalFilter,
  };
}
